import MuiImage from "mui-image"
import React from "react"
import { images } from "utils/images"

const Image = React.memo(function Image({ name, alt, ...props }) {
  const src = images[name]
  const [imageSource, setImageSource] = React.useState(
    name === undefined ? props?.src : src
  )

  const onImageError = (e) => {
    setImageSource(require("assets/img/placeholder.png"))
    if (props?.onError) {
      props.onError(e)
    }
  }

  return (
    <MuiImage
      alt={alt || name}
      fit="contain"
      duration={100}
      easing="ease-in"
      showLoading={false}
      errorIcon={require("assets/img/placeholder.png")}
      width={"1.2rem"}
      height={"1.2rem"}
      bgColor="transparent"
      {...props}
      src={imageSource || require("assets/img/placeholder.png")}
      onError={onImageError}
    />
  )
})

export default Image
